import {
  mapActions,
  mapGetters,
  mapMutations
} from 'vuex';
import CommandeSuccesI18n from './CommandeSuccess.i18n.js';

export default {

  components: {
    ...mapGetters(['user'])
  },

  props: {},

  data() {
    return {};
  },

  watch: {},

  methods: {
    ...mapActions(['payCommande']),
    ...mapMutations(['clearCart']),
    /**
     * Fonction pour confirmer le paiement.
     */
    confirmPayment() {
      const info = {
        id: this.$route.query.id,
        code: this.$route.query.code
      }
      this.payCommande(info).then(res => {
        this.clearCart()

      }).catch(err => {
        console.log(err)
      })
    }
  },

  mounted() {
    window.scrollTo(0, 0)
    if (this.$route.query.id && this.$route.query.code) {
      this.confirmPayment()
    } else {
      this.clearCart()
    }
  },

  i18n: CommandeSuccesI18n,

};